"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPackageIndexResponse = void 0;
class ContentPackageIndexResponse {
    constructor(params) {
        var _a;
        const offset = (_a = params.offset) !== null && _a !== void 0 ? _a : 0;
        const nextOffset = offset + params.limit;
        this.packages = params.packages;
        if (nextOffset < params.totalCount) {
            this.nextOffset = nextOffset;
        }
    }
}
exports.ContentPackageIndexResponse = ContentPackageIndexResponse;
//# sourceMappingURL=content-package-index-response.js.map